
export enum TargetingSearchFacetsEnum {
    subject = 'SUBJECT',
    continent = 'CONTINENT',
    country = 'COUNTRY',
    province = 'PROVINCE',
    county = 'COUNTY',
    city = 'CITY',
    language = 'LANGUAGE',

    // @TODO these work, but don't set their keys in the response, so we don't know what they are
    // outletSubject = 'OUTLET_SUBJECT',
    // outletContinent = 'OUTLET_CONTINENT',
    // outletCountry = 'OUTLET_COUNTRY',
    // outletProvince = 'OUTLET_PROVINCE',
    // outletCounty = 'OUTLET_COUNTY',
    // outletCity = 'OUTLET_CITY',

    // @TODO Currently doesn't work
    // outletLanguage = 'OUTLET_LANGUAGE',

    mediaType = 'MEDIA_TYPE',
    DMA = 'DMA',
    coverageFocus = 'COVERAGE_FOCUS',
    productFrequency = 'PRODUCT_FREQUENCY',
    productType = 'PRODUCT_TYPE',
    jobRole = 'JOB_ROLE',
    targetAudience = 'TARGET_AUDIENCE',
    marketSector = 'MARKET_SECTOR',
    targetAudienceRegion = 'AREA_OF_COVERAGE', // targetAudienceRegion is new property name, backend not changed yet
    mediaMarket = 'MEDIA_MARKET'
}
